import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {RecoveryDataItemModel} from '../models/recoveryDataItem.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RecoveryDataService {

  private readonly auditResultsProperty = 'auditLateStartingStudent';

  private REST_API_SERVER = environment.RECOVERY_DATA_SVC_URL;

  private recoveryDataItems: RecoveryDataItemModel[];
  private recoveryDataItemsSubject: Subject<any[]>;
  recoveryDataItemsObservable: Observable<any[]>;

  constructor( private httpClient: HttpClient) {
    this.recoveryDataItemsSubject = new Subject<any[]>();
    this.recoveryDataItemsObservable = this.recoveryDataItemsSubject.asObservable();
    this.getRecoveryData(null, null, null, null, null, 500);
  }

  getRecoveryData(studentId: number, schoolId: number, classroomId: number, startDate: string, endDate: string, limit: number): void {
    this.sendGetRequest(studentId, schoolId, classroomId, startDate, endDate, limit).subscribe((
        (data: any[]) => {
          this.recoveryDataItems = data[this.auditResultsProperty];
          this.recoveryDataItemsSubject.next(this.recoveryDataItems);
        }
    ));
  }

  public sendGetRequest(studentId?: number, schoolId?: number, classroomId?: number, startDate?: string, endDate?: string, limit?: number) {
      const args = Array.prototype.slice.call(arguments);
      const searchsParameters = ['studentId', 'schoolId', 'classroomId', 'startDate', 'endDate', 'limit'];
      let params = new HttpParams();
      for (let x = 0; x < args.length; x++) {
          if (args[x] !== null) {
              params = params.set(searchsParameters[x], args[x]);
          }
      }
      const URL = this.REST_API_SERVER + '?' + params.toString();
      return this.httpClient.get(URL);
  }
}
